import React from "react"
import * as styles from "./icons.module.scss"
import OutlinkClickable from "../outlinkClickable"
import classnames from "gpages/utils/classnames"
import { SIcon } from "../iconSymbols"

export const IconClickable = ({ icon, ...props }) => {
  return (
    <OutlinkClickable
      className={classnames(styles.icon, {
        [styles.iconBig]: icon === "gi_i_gcores",
      })}
      {...props}
    >
      <SIcon name={icon} />
    </OutlinkClickable>
  )
}

const IconsClickable = ({ list }) => {
  return (
    <div className={styles.icons}>
      {list.map(({ icon, ...props }) => (
        <IconClickable icon={icon} key={icon} {...props} />
      ))}
    </div>
  )
}

IconsClickable.displayName = "Icons"
export default IconsClickable
